<template>
	<div class="m-l-50 m-t-0 w-1200" style="color:#000;">
		<el-form ref="form" :model="form" :rules="rules" label-width="50px">
      <el-form-item label="名称" prop="name">
        <el-input v-model.trim="form.name" class="h-40 w-400"></el-input>
      </el-form-item>
      <el-form-item label="标题" prop="title">
        <el-input v-model.trim="form.title" class="h-40 w-400"></el-input>
      </el-form-item>
      <el-form-item label="" v-for="(item,index) in form.list">
        <div class="m-l-10 fl w-280">
          步骤{{index+1}}、名称：<el-input v-model.trim="item.buzhou" :value="item.buzhou" class="h-40 w-150 m-r-30"></el-input>
          图片：
        </div>
        <div class="m-l-10 fl w-800">
          <img style="width:285px;height: 160px;cursor:pointer;background-color:#aaa;" :src="item.content" class="fl m-r-10" v-on:click="handlePictureCardPreview(item.content)">
          <el-upload
            :action="uploadUrl"
            type="drag"
            class="fl"
            :thumbnail-mode="true"
            :on-success="(response, file, fileList)=>{return uploadSuccess(response, file, fileList,item)}"
            :show-file-list="false">
            <i class="el-icon-upload"></i>
            <div class="el-dragger__text" v-on:click="set_upload(index)">将文件拖到此处，或<em>点击上传</em>  jpg/png文件</div>
          </el-upload>
          <el-button size="small" type="danger" @click="configDel(index,form.list)" plain style="margin-top: 63px;margin-left: 10px;">删除步骤</el-button>
        </div>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" class="m-l-50" @click="configAdd(form.list)">增加步骤</el-button>
          <p class="m-l-50"><span v-if="form.list.length>0" style="color:#f00">备注：修改完成后请点击下方的保存，否则修改无效</span></p>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="add()" size="small" :loading="isLoading">保 存</el-button>
          <el-button @click="goback()" size="small">返 回</el-button>
        </el-form-item>
		</el-form>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" style="background-color:#aaa;" alt="">
    </el-dialog>
	</div>
</template>
<style scoped>
.form-pane{
  color:#333;
}
</style>
<script>
  import http from '../../../assets/js/http'
  import fomrMixin from '../../../assets/js/form_com'
  import preview from '../../Common/preview.vue'
  export default {
    data() {
      return {
        isLoading: false,
        dialogImageUrl: '',
        dialogVisible: false,
        fileList: [],
        form: {
          name: '',
          title: '',
          list: []
        },
        rules: {
          name: [
            { required: true, message: '请输入名称' }
          ],
          title: [
            { required: true, message: '请输入标题' }
          ]
        }
      }
    },
    methods: {
      configAdd(el) {
        el.push({ buzhou: '', content: [] })
      },
      configDel(i, el) {
        this.$confirm('确认删除步骤' + (i + 1) + '?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          el.splice(i, 1)
        }).catch(() => {
        })
      },
      add(form) {
        console.log('res = ', _g.j2s(this.form))
        this.$refs.form.validate((pass) => {
          if (pass) {
            this.isLoading = !this.isLoading
            this.apiPost('admin/guide', this.form).then((res) => {
              this.handelResponse(res, (data) => {
                _g.toastMsg('success', '添加成功')
                setTimeout(() => {
                  this.goback()
                }, 1500)
              }, () => {
                this.isLoading = !this.isLoading
              })
            })
          }
        })
      },
      handlePictureCardPreview(url) {
        this.dialogImageUrl = url
        this.dialogVisible = true
      },
      uploadSuccess(res, file, fileList, item) {
        item.content = res.data
      }
    },
    created() {
      _g.closeGlobalLoading()
    },
    components: {
      preview
    },
    mixins: [http, fomrMixin]
  }
</script>


// WEBPACK FOOTER //
// add.vue?4d15e2bc